import { InstructionComponentProps } from "../InstructionComponent"
import ImageTextComponent from "../../ImageTextComponent"

import IMG_1 from "../../../resources/tutorial/DOOR_IOS_2.png"
import IMG_2 from "../../../resources/tutorial/DOOR_IOS_3.png"
import IMG_3 from "../../../resources/tutorial/DOOR_IOS_4.png"

const AppLoginInstructions: InstructionComponentProps = {
    name: "Wie melde ich mich bei der DOOR Studie Connect App an?",
    path: "/help/patient/login",
    description: (
        <>
            Um am Praxistest teilzunehmen, ist es erforderlich, die
            DOOR Studie Connect App zu installieren. Die Funktionalität der App
            unterscheidet sich nicht zwischen iOS und Android.
        </>
    ),
    both: [
        <ImageTextComponent
            text={
                <>
                    Sobald die App heruntergeladen wurde, kann durch einen Click
                    auf das DOOR Studie Connect App Icon zur Anmeldung-Seite navigiert
                    werden.
                </>
            }
            images={[IMG_1]}
        />,
        <ImageTextComponent
            text={
                <>
                    Hier können Sie sich mit den Anmeldeinformationen, die vom
                    Studienteam bereitgestellt wurden, anmelden. Nach dem
                    Eintragen der E-Mail Adresse und des Passwortes, gelangen
                    Sie durch einen Klick auf den "Anmelden" Knopf auf
                    die Start-Seite der App.
                </>
            }
            images={[ IMG_2,IMG_3]}
        />
    ]
}

export default AppLoginInstructions
